import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import DeviceMappingMainGrid from '../components/DeviceMappingMainGrid';

const DashboardPage = ({ user, onLogout }) => {
  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <DeviceMappingMainGrid />
    </DashboardLayout>
  );
};

export default DashboardPage;
